// Michael: dts-bundle-generator and flowgen have an issue
// where process.env was "any" instead of being of the type
// provided by @types/node. This caused an issue building the flow-types.js
// file. You can remove this type once flow is gone.
type ENV = {
  NODE_ENV: string;
};

const isDevelopment = () => (process.env as ENV).NODE_ENV === 'development';

export default isDevelopment;
